import { api } from "./client";
import type {
  VerifyEmailResponse,
  SendOtpResponse,
  LoginResponse,
  VerifyTokenResponse,
} from "./types";

export const authApi = {
  verifyEmail: (email: string) =>
    api
      .post<VerifyEmailResponse>("/api/auth/verify-email", { email }, { timeout: 20_000 })
      .then((r) => r.data),

  sendOtp: (email: string) =>
    api
      .post<SendOtpResponse>("/api/auth/send-otp", { email }, { timeout: 20_000 })
      .then((r) => r.data),

  login: (email: string, otp: string) =>
    api.post<LoginResponse>("/api/auth/login", { email, otp }, { timeout: 20_000 }).then((r) => r.data),

  verify: () =>
    api.get<VerifyTokenResponse>("/api/auth/verify").then((r) => r.data),

  logout: () =>
    api.post<{ success: boolean }>("/api/auth/logout").then((r) => r.data),
};
